import React from 'react';

import './index.scss';

import ClickOnlyButton from 'components/atoms/Button/ClickOnlyButton';

const PcModal = ({
  modalIsOpen,
  acknowledgeMap,
  onClickCloseButton,
  onClickLastButton,
}) =>{
  const DispText = (text) => {
    return(
      text.map(line => (
        <div key={line} className="">
          {line}
          <br />
        </div>
      ))
    );
  };
  if(modalIsOpen){
    return(
      <div className="PM-overlay" onClick={onClickCloseButton}>
        <div className="PM-content" onClick={(e) => e.stopPropagation()}>
          <div className="PM-wrapper">
            <div className="PM-title">
              {acknowledgeMap.title}
            </div>
            <button className="PM-close-button" type="button" onClick={onClickCloseButton}>キャンセル</button>
            <div className="PM-information">
              <div className="PM-notice">
                {DispText(acknowledgeMap.notice)}
              </div>
              <div className="PM-judges">
                {DispText(acknowledgeMap.judges)}
              </div>
            </div>
            <ClickOnlyButton label='依頼を完了する' onClick={onClickLastButton} />
          </div>
        </div>
      </div>
    );
  }
  return null;
    

};

export default PcModal;